import React, { useEffect, useRef, useState } from 'react'
import { Box, Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import { Item } from '../../../common/snippets'
import DropDownOA from '../../../common/dropDownOA'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import { cargoServiceTypes, viewRateMatrixHeader } from './rateMatrixConstants'
import { FilterInput } from '../../../common/filterInput'
import { useTheme } from '@mui/material/styles'
import { connect } from 'react-redux'
import { updateAlertError, updateModal } from '../../../../store/common/common_action'
import { getFocApprConsTypeData, getServiceTypeListAllData, getCargoCompanyCitiesList, getViewRateMatrixTableData } from '../../../../store/generalSetting/GSAction'
import { focusElemnt, isEmpty, navigation3, removeDuplicatesFromArray } from '../../../common/helper'
import ReactHtmlTableToExcel from 'react-html-table-to-excel'
import TablePaginationCustom from '../../../common/TablePagination'
const ViewRateMatrix = (props) => {
    const { data, updateModal, updateAlertError, getFocApprConsTypeData, getServiceTypeListAllData, getCargoCompanyCitiesList, getViewRateMatrixTableData } = props
    const theme = useTheme()
    const { common, generalSettingReducer, } = data
    const { loginData, showModal, modalType } = common
    const tabelRef = useRef()
    const { focApprConsTypeData, serviceTypeListAll, serviceTypeListAll2, cargoCityListData } = generalSettingReducer
    const [tableData, setTableData] = useState([])
    const [showTable, setShowTable] = useState(false)
    const [filters, setFilters] = useState({ cargoServiceType: cargoServiceTypes[0], multiCargoServiceType: '', consType: '', sourceCity: '', destinationCity: '' })
    const [serviceTypeOpt, setServiceTypeOpt] = useState([])
    const [consTypeList, setConsTypeList] = useState([])
    const [srcCityList, setSrcCityList] = useState([])
    const [destCityList, setDestCityList] = useState([])
    const [filterValues, setFilterValues] = useState({});
    const [filteredData, setFilteredData] = useState([])
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const [page, setPage] = useState(0)
    const [totalNoOfRows, setTotalNoOfRows] = useState(0)
    useEffect(() => {
        if (!isEmpty(loginData)) {
            let obj = {
                intConsignmentSubTypeID: 0,
                intCompanyID: loginData?.intCompanyID,
                intConsignmentTypeID: 0,
                strSubType: "",
                intIsActive: 1,
                intIsDeleted: 0
            }
            getFocApprConsTypeData(obj, true, 24 * 60 * 60 * 1000)
        }
        if (!isEmpty(loginData)) {
            let objList = {
                intUserID: loginData?.intUserID,
                intCompanyID: loginData?.intCompanyID,
                intStateID: 0,
            }
            getCargoCompanyCitiesList(objList)
        }
    }, [loginData])

    useEffect(() => {
        if (cargoCityListData?.length > 0) {
            setSrcCityList(cargoCityListData)
            let selectedCity = cargoCityListData?.filter((item) => item?.CityID === loginData?.intBranchCityID)
            setFilters((prev) => ({
                ...prev,
                sourceCity: selectedCity[0]
            }))
        }
    }, [cargoCityListData])

    useEffect(() => {
        if (filters?.sourceCity !== '' || filters?.sourceCity !== undefined) {
            let destList = cargoCityListData?.filter((item) => item?.CityID !== filters?.sourceCity?.CityID)
            destList.unshift({ CityID: 0, CityName: 'All' });
            setDestCityList(destList)
            setFilters((prev) => ({
                ...prev,
                destinationCity: destList[0]
            }))
        }
    }, [filters?.sourceCity])

    useEffect(() => {
        if (serviceTypeListAll?.length > 0) {
            let data = serviceTypeListAll?.filter((val) => serviceTypeListAll2?.length > 0 ? serviceTypeListAll2?.[0]?.CargoServiceTypeID === 0 ? val?.ServiceTypeID === 2 : true : true)
            if (Number(serviceTypeListAll2?.[0]?.CargoServiceTypeID) === 1) {
                setFilters((prev) => ({
                    ...prev,
                    cargoServiceType: cargoServiceTypes[1]
                }))
            } else {
                setFilters((prev) => ({
                    ...prev,
                    cargoServiceType: cargoServiceTypes[0]
                }))
            }
            setServiceTypeOpt(data)
            setFilters((prev) => ({
                ...prev,
                multiCargoServiceType: data[0]
            }))
        } else {
            setServiceTypeOpt([])
            setFilters((prev) => ({
                ...prev,
                multiCargoServiceType: ''
            }))

        }
    }, [serviceTypeListAll, serviceTypeListAll2])
    useEffect(() => {
        if (focApprConsTypeData?.length > 0) {
            let newData = [{ id: 0, name: 'All' }]
            focApprConsTypeData.map(function (obj) {
                newData.push({
                    id: obj.ConsignmentSubTypeID,
                    name: obj.SubType,
                })
            })
            newData = removeDuplicatesFromArray(newData, `id`)
            newData.sort((a, b) => a.name.localeCompare(b.name))
            setConsTypeList(newData)
            setFilters((prev) => ({
                ...prev,
                consType: newData[0]
            }))
        } else {
            setConsTypeList([])
        }
    }, [focApprConsTypeData])
    useEffect(() => {
        setTableData(filteredData)
    }, [filteredData])
    useEffect(() => {
        const filteredDataTemp = filteredData.filter((item) => {
            return viewRateMatrixHeader?.every((column) => {
                const filterValue = filterValues[column.field]; // Can be 0 or any other value
                const value = item[column.field]; // The value in the row
                if (filterValue !== undefined && filterValue !== "") {
                    return value != null && value?.toString()?.toLowerCase()?.includes(filterValue?.toString()?.toLowerCase());
                }
                return true;
            });
        });
        // setTableData(filteredDataTemp);
        setTableData(filteredDataTemp.length > 0 ? filteredDataTemp : []);
    }, [filterValues]);
    useEffect(() => {
        // setTimeout(() => {
        focusElemnt('multi_cargo_service_type')
        // }, 1000)
    }, [])
    const handleLoad = (page=0, rowsPerPage=10) => {
        if (filters?.cargoServiceType === '') {
            updateAlertError({ show: true, msg: 'Please Select Cargo Service Type', success: false, nextId: `` })
        } else if (filters?.multiCargoServiceType === '') {
            updateAlertError({ show: true, msg: 'Please Select Service Type', success: false, nextId: `` })
        } else if (filters?.consType === '') {
            updateAlertError({ show: true, msg: 'Please Select Consignment Type', success: false, nextId: `` })
        } else if (filters?.sourceCity === '') {
            updateAlertError({ show: true, msg: 'Please Select Source City', success: false, nextId: `` })
        } else if (filters?.destinationCity === '') {
            updateAlertError({ show: true, msg: 'Please Select Destination City', success: false, nextId: `` })
        } else {
            let body = {
                CompanyID: loginData?.intCompanyID,
                ServiceType: filters?.multiCargoServiceType?.ServiceTypeID,
                ConsignmentID: filters?.consType?.id,
                SourceCityID: filters?.sourceCity?.CityID,
                DestinationCityID: filters?.destinationCity?.CityID,
                PageNo:page+1,
                NoOfRows:rowsPerPage
            }
            getViewRateMatrixTableData(body).then((res) => {
                if (res.status === 'Success') {
                    let data = res?.Data?.Table
                    setFilteredData(data)
                    setTotalNoOfRows(res?.Data?.Table1?.[0]?.TotalRows)
                } else {
                    setFilteredData([])
                    setTotalNoOfRows(0)
                    updateAlertError({ show: true, msg: 'No Data', nextId: '' })
                }
            }).catch((error) => {
                setFilteredData([])
                setTotalNoOfRows(0)

                updateAlertError({ show: true, msg: error, nextId: '' })
            })
        }
        setShowTable(true)
    }
    const InsideRowContent = ({ item, index }) => {
        return (
            <TableRow key={`foc-approval-${index}`} style={{ minHeight: '40px' }}>
                <TableCell style={{ fontSize: '12px', height: '40px', fontFamily: 'Roboto', fontWeight: '400', color: '#444444', padding: '0px 16px 0px 16px', textAlign: 'left' }}> {item?.SourceCity} </TableCell>
                <TableCell style={{ fontSize: '12px', height: '40px', fontFamily: 'Roboto', fontWeight: '400', color: '#444444', padding: '0px 16px 0px 16px', textAlign: 'left' }}> {item.DestiationCity} </TableCell>
                <TableCell style={{ fontSize: '12px', height: '40px', fontFamily: 'Roboto', fontWeight: '400', color: '#444444', padding: '0px 16px 0px 16px', textAlign: 'right' }}> {item.ConsignmentID} </TableCell>
                <TableCell style={{ fontSize: '12px', height: '40px', fontFamily: 'Roboto', fontWeight: '400', color: '#444444', padding: '0px 16px 0px 16px', textAlign: 'left' }}> {item.ConsignmentType} </TableCell>
                <TableCell style={{ fontSize: '12px', height: '40px', fontFamily: 'Roboto', fontWeight: '400', color: '#444444', padding: '0px 16px 0px 16px', textAlign: 'left' }}> {item.RateType} </TableCell>
                <TableCell style={{ fontSize: '12px', height: '40px', fontFamily: 'Roboto', fontWeight: '400', color: '#444444', padding: '0px 16px 0px 16px', textAlign: 'right' }}> {item.FromKg} </TableCell>
                <TableCell style={{ fontSize: '12px', height: '40px', fontFamily: 'Roboto', fontWeight: '400', color: '#444444', padding: '0px 16px 0px 16px', textAlign: 'right' }}> {item.ToKg} </TableCell>
                <TableCell style={{ fontSize: '12px', height: '40px', fontFamily: 'Roboto', fontWeight: '400', color: '#444444', padding: '0px 16px 0px 16px', textAlign: 'right', width: '160px' }}> {item.Freight} </TableCell>
                <TableCell style={{ fontSize: '12px', height: '40px', fontFamily: 'Roboto', fontWeight: '400', color: '#444444', padding: '0px 16px 0px 16px', textAlign: 'right' }}> {item.OtherCharges} </TableCell>
            </TableRow>
        )
    }
    const clickElement = (elementID) => {
        elementID && document.getElementById(elementID) && document.getElementById(elementID).click()
    }
    const handleChangeContain = (e, name) => {
        let value = e.target.value;
        setFilterValues((prevFilterValues) => ({
            ...prevFilterValues,
            [name]: value
        }));
    }
    return (
        <>
            <Box sx={{ display: 'flex', justifyContent: 'start', alignItems: 'center', margin: '10px 0', paddingTop:'10px' }}>
                <Box sx={{ display: 'flex', gap: '16px' }} className="reportButtons">
                    <Item sx={{...sx.itemsx, width:'14%'}}>
                        <DropDownOA
                            id={'kgKmCargoServiceType'}
                            label={'Cargo Service Type'}
                            data={cargoServiceTypes}
                            defaultvalue={filters?.cargoServiceType?.name || ''}
                            value={filters?.cargoServiceType?.name || ''}
                            onSelect={(val) => {
                                setShowTable(false)
                                setFilters((prev) => ({
                                    ...prev,
                                    cargoServiceType: val
                                }))
                                setShowTable(false)
                            }}
                            disabled={true}
                            idKey={`id`}
                            dataKey={`name`}
                            minWidth="100%"
                            nextId={''}
                            prevId={``}
                            onSelResetVal={true}

                        />
                    </Item>
                    <Item sx={{...sx.itemsx, width:'14%'}}>
                        <DropDownOA
                            id='multi_cargo_service_type'
                            label={'Select Service Type'}
                            data={serviceTypeOpt || []}
                            defaultvalue={filters?.multiCargoServiceType?.ServiceType || ''}
                            value={filters?.multiCargoServiceType?.ServiceType || ''}
                            width="100%"
                            searchPlaceholder={'Search Service Type'}
                            dataKey={`ServiceType`}
                            idKey={`ServiceTypeID`}
                            listWidth="100%"
                            // resetFlag={resetFilter}
                            onSelect={(val) => {
                                setShowTable(false)
                                setFilters((prev) => ({
                                    ...prev,
                                    multiCargoServiceType: val
                                }))
                                setShowTable(false)
                            }}
                            nextId={'ConsType'}
                            prevId={``}
                            onSelResetVal={true}

                        />
                    </Item>
                    <Item sx={{...sx.itemsx, width:'14%'}}>
                        <DropDownOA
                            id='ConsType'
                            label={'Consignment Type'}
                            data={consTypeList || []}
                            defaultvalue={filters?.consType?.name || ''}
                            value={filters?.consType?.name || ''}
                            width="100%"
                            searchPlaceholder={'Search Consignment Type'}
                            dataKey={`name`}
                            idKey={`id`}
                            listWidth="100%"
                            // resetFlag={resetFilter}
                            onSelect={(val) => {
                                setShowTable(false)
                                setFilters((prev) => ({
                                    ...prev,
                                    consType: val
                                }))
                                setShowTable(false)
                            }}
                            nextId='Source_City'
                            prevId={'multi_cargo_service_type'}
                            onSelResetVal={true}
                        />
                    </Item>
                    <Item sx={{...sx.itemsx, width:'14%'}}>
                        <DropDownOA
                            id={'Source_City'}
                            label={'Source City'}
                            searchPlaceholder={'Search Source City'}
                            data={srcCityList || []}
                            defaultvalue={filters?.sourceCity?.CityName || ''}
                            value={filters?.sourceCity?.CityName || ''}
                            onSelect={(val) => {
                                setFilters((prev) => ({
                                    ...prev,
                                    sourceCity: val
                                }))
                                setShowTable(false)
                            }}
                            onReset={() => {
                                setFilters((prev) => ({
                                    ...prev,
                                    sourceCity: ''
                                }))
                            }}
                            onSelResetVal={true}
                            idKey={`CityID`}
                            dataKey={`CityName`}
                            nextId={`destination_City`}
                            prevId={`ConsType`}
                        />
                    </Item>
                    <Item sx={{...sx.itemsx, width:'14%'}}>
                        <DropDownOA
                            id={'destination_City'}
                            label={'Destination City'}
                            searchPlaceholder={'Search Destination City'}
                            data={destCityList || []}
                            defaultvalue={filters?.destinationCity?.CityName || ''}
                            value={filters?.destinationCity?.CityName || ''}
                            onSelect={(val) => {
                                setFilters((prev) => ({
                                    ...prev,
                                    destinationCity: val
                                }))
                                setShowTable(false)
                            }}
                            onReset={() => {
                                setFilters((prev) => ({
                                    ...prev,
                                    destinationCity: ''
                                }))
                            }}
                            onSelResetVal={true}
                            idKey={`CityID`}
                            dataKey={`CityName`}
                            nextId={`load_btn`}
                            prevId={`Source_City`}
                        />
                    </Item>
                    <Item sx={{ ...sx.itemsx, padding: 0 }} className="disabled-wrapper">
                        <Button
                            variant="outlined"
                            onClick={() => { handleLoad(page, rowsPerPage) }}
                            onKeyDown={(e) => navigation3(e, 'excel_btn', 'destination_City', () => { })}
                            id={'load_btn'}
                            sx={{ width: '100%', paddingY: '6px !important' }}
                            className="btn cancel-btn"
                        >
                            LOAD
                        </Button>
                    </Item>
                    <Box >
                        <Button
                            variant="outlined"
                            onClick={(e) => { clickElement('xls-buttons-dispatch') }}
                            onKeyDown={(e) => navigation3(e, 'multi_cargo_service_type', 'load_btn', () => { })}
                            id={'excel_btn'}
                            startIcon={<svg width="15" height="20" viewBox="0 0 15 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M2.5 0C1.12109 0 0 1.12109 0 2.5V17.5C0 18.8789 1.12109 20 2.5 20H12.5C13.8789 20 15 18.8789 15 17.5V6.25H10C9.30859 6.25 8.75 5.69141 8.75 5V0H2.5ZM10 0V5H15L10 0ZM6.08203 9.77344L7.5 11.8008L8.91797 9.77344C9.21484 9.34766 9.80078 9.24609 10.2227 9.54297C10.6445 9.83984 10.75 10.4258 10.4531 10.8477L8.64453 13.4375L10.457 16.0234C10.7539 16.4492 10.6523 17.0312 10.2266 17.3281C9.80078 17.625 9.21875 17.5234 8.92188 17.0977L7.5 15.0703L6.08203 17.0977C5.78516 17.5234 5.19922 17.625 4.77734 17.3281C4.35547 17.0312 4.25 16.4453 4.54688 16.0234L6.35547 13.4375L4.54297 10.8516C4.24609 10.4258 4.34766 9.84375 4.77344 9.54688C5.19922 9.25 5.78125 9.35156 6.07812 9.77734L6.08203 9.77344Z" fill="#FE5200" />
                            </svg>}
                            sx={{ width: '100%', paddingY: '6px !important' }}
                            className="btn cancel-btn"
                        >
                            DOWNLOAD EXCEL
                        </Button>
                        <ReactHtmlTableToExcel
                            id="xls-buttons-dispatch"
                            table="tableExcel"
                            filename={'View Rate Matrix'}
                            sheet="sheet 1"
                            buttonText="EXPORT AS EXCEL"
                            className="excel-button"
                        />
                    </Box>
                </Box>
            </Box>
            {
                showTable && <Box style={{ paddingTop:'10px'}}>

                    <TableContainer component={Paper} style={{ marginBottom: '5px', display: 'none' }}>
                        <Table
                            id='tableExcel'
                            stickyHeader
                            size="small"
                            aria-label="a dense table"
                            style={{
                                '&.MuiTableCell-root': {
                                    padding: '6px 8px!important',
                                },
                            }}
                        >
                            <TableHead style={{ position: `sticky`, top: `0`, zIndex: 2 }}>
                                <TableRow>
                                    {viewRateMatrixHeader.map((col, index) => (
                                        <TableCell
                                            key={`TH-${index}`}
                                            style={{
                                                ...col.headerSx,
                                                backgroundColor: '#DAEDFE',
                                                height: '40px',
                                                fontSize: '20px',
                                                fontWeight: '700',
                                                color: '#444',
                                            }}
                                        >
                                            {col.headerName}
                                        </TableCell>
                                    ))}
                                </TableRow>
                                <TableRow>
                                    <TableCell
                                        colSpan={9}
                                        style={{
                                            backgroundColor: '#F5FAFE',
                                            height: '40px',
                                            fontSize: '20px',
                                            fontWeight: '700',
                                            color: '#444',
                                            textAlign: 'left'
                                        }}
                                    >
                                        Source City :{filters?.sourceCity?.CityName}
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            {tableData?.length < 1 ? (
                                <>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell colSpan={9}>
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        marginTop: '20px',
                                                        marginBottom: '20px',
                                                        color: 'red',
                                                        fontSize: '12px',
                                                        lineheight: '16px',
                                                        letterspacing: '0.24px',
                                                    }}
                                                >
                                                    <span>No results found. Please refine your search parameters and search again.</span>
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                </>
                            ) : tableData?.length >= 1 ? (
                                <TableBody
                                    className="filter-data-row"
                                    style={{
                                        textAlign: 'center',
                                        fontSize: '20px',
                                        lineheight: '16px',
                                        letterspacing: '0.24px',
                                        fontWeight: '500',
                                        marginLeft: '5px',
                                    }}
                                >
                                    {tableData?.map((item, index) => (
                                        <InsideRowContent item={item} index={index} key={index} />
                                    ))}
                                </TableBody>
                            ) : (
                                ''
                            )}
                        </Table>
                    </TableContainer>
                    <TableContainer component={Paper} className='scrollBlue' ref={tabelRef} style={{ marginBottom: '5px', maxHeight: `${window.innerHeight - tabelRef.current?.getBoundingClientRect()?.top - 80}px` }}>
                        <Table
                            id='tableExcel'
                            stickyHeader
                            size="small"
                            aria-label="a dense table"
                            style={{
                                '&.MuiTableCell-root': {
                                    padding: '6px 8px!important',
                                },
                            }}
                        >
                            <TableHead style={{ position: `sticky`, top: `0`, zIndex: 2 }}>
                                <TableRow>
                                    {viewRateMatrixHeader.map((col, index) => (
                                        <TableCell
                                            key={`TH-${index}`}
                                            style={{
                                                ...col.headerSx,
                                                backgroundColor: '#DAEDFE',
                                                height: '40px',
                                                fontSize: '12px',
                                                fontWeight: '700',
                                                color: '#444',
                                            }}
                                        >
                                            {col.headerName}
                                        </TableCell>
                                    ))}
                                </TableRow>
                                <TableRow>
                                    {viewRateMatrixHeader?.map((col, index) => (
                                        <TableCell
                                            key={`TH-${index}`}
                                            style={{
                                                ...col.headerSx,
                                                height: '40px',
                                                fontSize: '12px',
                                                fontWeight: '600',
                                                color: '#444',
                                            }}
                                        >
                                            {col.showfilter ? (
                                                // <FilterInput label="Contains" />
                                                <FilterInput label="Contains" onChange={(e) => handleChangeContain(e, col.field)} />
                                            ) : (
                                                ''
                                            )}
                                        </TableCell>
                                    ))}
                                </TableRow>
                                <TableRow>
                                    <TableCell
                                        colSpan={9}
                                        style={{
                                            backgroundColor: '#F5FAFE',
                                            height: '40px',
                                            fontSize: '12px',
                                            fontWeight: '700',
                                            color: '#444',
                                            textAlign: 'left'
                                        }}
                                    >
                                        Source City :{filters?.sourceCity?.CityName}
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            {tableData?.length < 1 ? (
                                <>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell colSpan={14}>
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        marginTop: '20px',
                                                        marginBottom: '20px',
                                                        color: 'red',
                                                        fontSize: '12px',
                                                        lineheight: '16px',
                                                        letterspacing: '0.24px',
                                                    }}
                                                >
                                                    <span>No results found. Please refine your search parameters and search again.</span>
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                </>
                            ) : tableData?.length >= 1 ? (
                                <TableBody
                                    className="filter-data-row"
                                    style={{
                                        textAlign: 'center',
                                        fontSize: '12px',
                                        lineheight: '16px',
                                        letterspacing: '0.24px',
                                        fontWeight: '500',
                                        marginLeft: '5px',
                                    }}
                                >
                                    {tableData?.map((item, index) => (
                                        <InsideRowContent item={item} index={index} key={index} />
                                    ))}
                                </TableBody>
                            ) : (
                                ''
                            )}
                        </Table>
                    </TableContainer>
                    <TablePaginationCustom totRowCount={totalNoOfRows} rowsPerPageOptions={[10, 20, 50, 100, 200, 500]} rowsPerPage={rowsPerPage} page={page} handleChangePage={(event, newPage) => {
                        setPage(newPage); handleLoad(newPage, rowsPerPage)
                    }} handleChangeRowsPerPage={(event) => {
                        setRowsPerPage(parseInt(event.target.value, 10));
                        setPage(0);
                        handleLoad(0, parseInt(event.target.value, 10))
                    }} />
                </Box>
            }
        </>
    )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { updateModal, getFocApprConsTypeData, getServiceTypeListAllData, updateAlertError, getCargoCompanyCitiesList, getViewRateMatrixTableData }
export default connect(mapStateToProps, mapDispatchToProps)(ViewRateMatrix)
// export default ViewRateMatrix